module.exports = __webpack_public_path__ + "img/startapplication-sm.2357bd50.png";